import React from 'react';
import PropTypes from 'prop-types';
import { TypeActionCodes, ReclamationActionDetailCodes, ReclamationActionDetailType } from 'constants.js';
import { connect } from 'react-redux';
import { addAction } from 'store/reclamation/reclamationsActions';
import ConfirmationReceptionFournisseur from './ConfirmationReceptionFournisseur';

class ConfirmationReceptionFournisseurContainer extends React.Component {

    handleClickSave = (date, memo) => {
        const { actionId, reclamationId, addAction } = this.props;

        let actionData = {
            code: TypeActionCodes.Reponse,
            parentReclamationActionId: actionId,
            details: [
                {
                    code: ReclamationActionDetailCodes.Resultat,
                    type: ReclamationActionDetailType.Date,
                    libelle: "Date de confirmation",
                    position: 0,
                    valeurDate: date
                },
                {
                    code: ReclamationActionDetailCodes.Memo,
                    type: ReclamationActionDetailType.Texte,
                    libelle: "Mémo",
                    position: 1,
                    valeurString: memo
                }],
            reponseAttendue: false
        };


        addAction(reclamationId, actionData, actionId);
    }





    render() {
        const { isAdding } = this.props;

        return (
            <ConfirmationReceptionFournisseur
                onClickSave={this.handleClickSave}
                isAdding={isAdding}                
            />
        );
    }
}

ConfirmationReceptionFournisseurContainer.propTypes = {
    actionId: PropTypes.number.isRequired,
    reclamationId: PropTypes.number.isRequired
};




const mapStateToProps = (state, ownProps) => ({
    isAdding: state.common.addActionData.actionId === ownProps.actionId
});


const mapDispatchToProps = dispatch => ({
    addAction: (reclamationId, actionData, actionId) => dispatch(addAction(reclamationId, actionData, actionId))
});

export default connect(mapStateToProps, mapDispatchToProps)(ConfirmationReceptionFournisseurContainer);